import { useCallback, useState } from 'react';
import type { NavItemPopoverState } from '../../../components/platform/types';

const CLOSED_POPOVER: NavItemPopoverState = { groupId: null, isPinned: false };

/**
 * Owns the single open-popover slot for the collapsed platform rail.
 *
 * Only one collapsed-rail popover (a nav group's L2 popover, or the ProjectSwitcher) may be open at a
 * time, so the slot is one value rather than per-popover local state — this is what prevents two
 * popovers overlapping while a leaving popover's hover-close debounce is still pending. `groupId`
 * identifies the open popover; `isPinned` only changes the close behaviour (a pinned popover survives
 * pointer-leave and is dismissed by re-click / outside-click / navigation, not by hover-out).
 */
export function useNavItemPopover() {
  const [navItemPopover, setNavItemPopover] = useState<NavItemPopoverState>(CLOSED_POPOVER);

  const closeNavItemPopover = useCallback(() => setNavItemPopover(CLOSED_POPOVER), []);

  return { navItemPopover, setNavItemPopover, closeNavItemPopover };
}
